import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { RouterContext } from '../router';
import { ToastContainer } from 'react-toastify';
import context from '../components/Administration/context/shared';

export const Route = createRootRouteWithContext<RouterContext>()({
    component: RootComponent,
})

function RootComponent() {

    const { theme } = context;

    return (
        <>
            <Outlet />
        </>
    )
}
